const CATEGORY_ORDER = ["Performance", "Suspension", "Wheel & Tire", "Exterior", "Interior", "Misc"];
const DISPLAY_NAMES = { "Wheel & Tire": "Wheels & Tires", Misc: "Other" };

export function normalizeModCategory(value) {
  const category = String(value || "").toLowerCase().replace(/&/g, "and").replace(/[^a-z0-9]+/g, " ").trim();
  if (/performance|engine|power/.test(category)) return "Performance";
  if (/suspension|chassis/.test(category)) return "Suspension";
  if (/(wheel|tire|tyre)/.test(category)) return "Wheel & Tire";
  if (/exterior|body/.test(category)) return "Exterior";
  if (/interior|cabin/.test(category)) return "Interior";
  if (/misc|other/.test(category)) return "Misc";
  return "Misc";
}

// Only the active chapter is used because later chapters may contain carried-forward copies.
export function getVehicleCurrentMods(car = {}) {
  const stages = Array.isArray(car.stages) ? car.stages : [];
  const currentStage = stages.find((stage) => stage.id === car.currentStageId) || stages.find((stage) => stage.isCurrent) || stages[0];
  const source = currentStage && Object.prototype.hasOwnProperty.call(currentStage, "mods") ? currentStage.mods : car.mods;
  return flattenMods(source);
}

export function calculateBuilderDna(garageCars = []) {
  const counts = Object.fromEntries(CATEGORY_ORDER.map((category) => [category, 0]));
  garageCars.forEach((car) => getVehicleCurrentMods(car).forEach((mod) => { counts[normalizeModCategory(mod.category)] += 1; }));
  const totalMods = Object.values(counts).reduce((sum, count) => sum + count, 0);
  if (!totalMods) return { totalMods: 0, buildCount: garageCars.length, primaryCategory: null, label: "Builder DNA is not available yet", categories: [] };

  const categories = CATEGORY_ORDER.map((category, order) => ({ category, displayName: DISPLAY_NAMES[category] || category, count: counts[category], order }))
    .filter((item) => item.count > 0)
    .sort((a, b) => b.count - a.count || a.order - b.order)
    .map((item) => ({ ...item, percentage: Math.round(item.count / totalMods * 100) }));
  const roundingDifference = 100 - categories.reduce((sum, item) => sum + item.percentage, 0);
  categories[0].percentage += roundingDifference;
  const first = categories[0];
  const secondPercentage = categories[1]?.percentage || 0;
  const focusedCategoryName = first.category === "Misc" ? "Other" : first.category;
  const label = totalMods < 3
    ? "Builder DNA is still developing"
    : first.percentage >= 40 && first.percentage - secondPercentage >= 10
      ? `${focusedCategoryName}-focused builder`
      : "Balanced builder";
  return { totalMods, buildCount: garageCars.length, primaryCategory: first.category, label, categories };
}

function flattenMods(source, inheritedCategory = "") {
  if (!source) return [];
  if (Array.isArray(source)) return source.flatMap((item) => flattenMods(item, inheritedCategory));
  if (typeof source === "string") return source.trim() ? [{ category: inheritedCategory || "Misc" }] : [];
  if (typeof source !== "object") return [];
  const category = source.category || source.modCategory || inheritedCategory;
  const meaningful = source.partName || source.name || source.title || source.description || source.brand || source.partNumber;
  if (meaningful) return [{ ...source, category: category || "Misc" }];
  return Object.entries(source).flatMap(([key, value]) => {
    if (["id", "createdAt", "updatedAt", "metadata"].includes(key)) return [];
    return flattenMods(value, key);
  });
}
